export const formatDuration = (
  duration: number,
  showSeconds = true,
  showMinutes = true
) => {
  // Handle NaN and invalid numbers
  if (isNaN(duration) || !isFinite(duration)) {
    return '0s';
  }
  
  const durationInSeconds = duration / 1000;
  let hours: number;
  let minutes: number;
  let seconds: number;

  if (durationInSeconds > 0) {
    hours = Math.abs(Math.floor(durationInSeconds / 3600));
    minutes = Math.abs(Math.floor((durationInSeconds % 3600) / 60));
    seconds = Math.abs(Math.floor((durationInSeconds % 3600) % 60));
  } else {
    hours = Math.abs(Math.ceil(durationInSeconds / 3600));
    minutes = Math.abs(Math.ceil((durationInSeconds % 3600) / 60));
    seconds = Math.abs(Math.ceil((durationInSeconds % 3600) % 60));
  }

  const durationArray = [];

  if (hours != 0) {
    durationArray.push(`${hours}h`);
    // Only add minutes to the array if showMinutes is true and hours are greater than 0
    if (showMinutes) {
      durationArray.push(`${Math.abs(minutes)}m`);
    }
  } else {
    // If hours are 0, add minutes and seconds based on the flags
    if (showMinutes) {
      durationArray.push(`${minutes}m`);
    }
    if (showSeconds) {
      durationArray.push(`${Math.abs(seconds)}s`);
    }
  }

  let durationString = durationArray
    .join(' ')
    .replace(/\b0(m|s|h)\b/g, '')
    .trim();

  // Handle the case where no time units are displayed
  if (!durationString) {
    durationString = showSeconds ? '0s' : showMinutes ? '0m' : '0h';
  }

  const deviationPrefix = duration < 0 ? '-' : '';
  return `${deviationPrefix}${durationString}`;
};

export const roundMillisecondsToNearestHour = (
  milliseconds: number
): number => {
  return Math.round(milliseconds / 1000 / 60 / 60);
};
